"use strict";
const staleSessionBanners = document.querySelector(".js-stale-session-banner");
function isValidLoginState(state) {
    return state === "LoggedIn" || state === "LoggedOut";
}
if (staleSessionBanners) {
    const loginChannel = new BroadcastChannel("rezstream-login");
    loginChannel.addEventListener("message", (event) => {
        const message = event.data;
        if (!isValidLoginState(message)) {
            return;
        }
        staleSessionBanners.hidden = false;
        // It's possible to have multiple banners show up at once if you for instance
        // both log out and log in with another tab.
        // We don't want this to happen, so before unhiding the specific banner we need,
        // Make sure all the other banners are hidden.
        const allBanners = document.querySelectorAll(".js-stale-session-banner [data-banner-type]");
        for (const banner of allBanners) {
            banner.hidden = true;
        }
        const relevantBanner = document.querySelector(`.js-stale-session-banner [data-banner-type="${message}"]`);
        if (relevantBanner) {
            relevantBanner.hidden = false;
        }
        const submitElements = document.querySelectorAll('form [type="submit"]');
        for (const element of submitElements) {
            element.setAttribute("disabled", "");
        }
        document.addEventListener("submit", (submitEvent) => {
            submitEvent.preventDefault();
        });
    });
    const loginState = staleSessionBanners.getAttribute("data-login-state");
    if (loginState) {
        loginChannel.postMessage(loginState);
    }
}
